import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import { FREQUENTLY_ASKED_QUESTION_IDS } from '@/components/HowToWin/helpers/constants';
import { FrequentlyAskedQuestion } from '@/components/HowToWin';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    variant: 'desktop' | 'mobile';
};

export const HowToWinFaq = ({ variant }: Props) => {
    const { formatMessage } = useIntl();
    const isMobile = variant === 'mobile';

    const title = formatMessage({ id: 'howToWinRedesigned.faq.title' });
    const description = formatMessage({ id: 'howToWinRedesigned.faq.description' });

    if (isMobile) {
        return (
            <section
                className="mx-sm mt-md flex flex-col"
                data-testid="howToWinFaq-mobile"
            >
                <div>
                    <H2 className="mb-xs">{title}</H2>
                    <BodyPrimary>{description}</BodyPrimary>
                </div>
                <hr className="mt-md w-full border-0 border-t border-border-secondary" />
                <div>
                    {FREQUENTLY_ASKED_QUESTION_IDS.map((id) => (
                        <FrequentlyAskedQuestion
                            id={id}
                            key={id}
                        />
                    ))}
                </div>
            </section>
        );
    }

    return (
        <section
            className="mx-auto flex w-full max-w-[1596px] flex-col justify-between gap-xl pb-md pt-[96px] mdMin:flex-row"
            data-testid="howToWinFaq-desktop"
        >
            <div className="w-full mdMin:w-2/5 tabletMin:max-w-none">
                <H2 className="mb-sm">{title}</H2>
                <BodyPrimary>{description}</BodyPrimary>
            </div>
            <div className="w-full max-w-[807px]">
                {FREQUENTLY_ASKED_QUESTION_IDS.map((id) => (
                    <FrequentlyAskedQuestion
                        id={id}
                        key={id}
                    />
                ))}
            </div>
        </section>
    );
};
